const TTL_SECONDS = 30 * 24 * 60 * 60;
const FUTURE_SKEW_SECONDS = 5 * 60;

function fbcTimestamp(fbc) {
  if (!fbc || typeof fbc !== "string") return null;
  const match = fbc.match(/^fb\.\d+\.(\d{10,13})\./);
  if (!match) return null;
  const raw = Number(match[1]);
  if (!Number.isFinite(raw) || raw <= 0) return null;
  return raw > 9999999999 ? Math.floor(raw / 1000) : raw;
}

function capturedAt(utm) {
  if (!utm || typeof utm !== "object") return null;
  if (utm.captured_at) {
    const numeric = Number(utm.captured_at);
    if (Number.isFinite(numeric) && numeric > 0) return numeric;
    const parsed = Date.parse(utm.captured_at);
    if (Number.isFinite(parsed)) return Math.floor(parsed / 1000);
  }
  return fbcTimestamp(utm._fbc);
}

export function freshUtmData(utm, now = Math.floor(Date.now() / 1000)) {
  const ts = capturedAt(utm);
  if (!ts) return null;
  if (ts > now + FUTURE_SKEW_SECONDS) return null;
  if (now - ts > TTL_SECONDS) return null;
  return utm;
}

export function readFreshUtmData() {
  try {
    const match = document.cookie.match(/utm_data=([^;]+)/);
    if (!match) return null;
    return freshUtmData(JSON.parse(decodeURIComponent(match[1])));
  } catch (e) {
    return null;
  }
}
